<template>
  <div id="addReportTaskContainer">
      <form id="monitorTaskForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.taskName')}}:</div>
                <input name="taskName" :placeholder="$t('Monitor.task.taskName')" v-model="monitorTask.taskName"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox" style="display: none">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.product')}}:</div>
                <ejs-dropdownlist :dataSource="productList" v-model="monitorTask.product" name="product"
                    :fields="fieldsFormat" @change="productChange" ></ejs-dropdownlist>
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.diskSpaceThreshold')}}:</div>
              <input name="spaceThreshold" :placeholder="$t('Monitor.record.diskSpaceThreshold')" v-model="monitorThresholdPo.spaceThreshold"
                     class="e-input e-input-group" maxlength="20" />
              <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.cpuThreshold')}}:</div>
                <input name="cpuThreshold" :placeholder="$t('Monitor.record.cpuThreshold')" v-model="monitorThresholdPo.cpuThreshold"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.memoryThreshold')}}:</div>
                <input name="memoryThreshold" :placeholder="$t('Monitor.record.memoryThreshold')" v-model="monitorThresholdPo.memoryThreshold"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.sampleStart')}}:</div>
                <ejs-datetimepicker :format="dateFormat" v-model="monitorTask.sampleStart" ref="startTime" name="sampleStart"
                    class="e-input" :allowEdit="false" @keydown.native="stopEvent" :locale="locale"></ejs-datetimepicker>
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.sampleEnd')}}:</div>
                <ejs-datetimepicker :format="dateFormat" v-model="monitorTask.sampleEnd" ref="endTime" name="sampleEnd"
                    class="e-input" :allowEdit="false" :min="monitorTask.sampleStart" @keydown.native="stopEvent" :locale="locale"></ejs-datetimepicker>
                <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
    import { FormValidator } from "@syncfusion/ej2-vue-inputs";
    import mixin from '../../../mixin/mixin';

    export default {
        name: 'AddReportTask',
        mixins: [mixin],
        displayFlag : 'none',
        props: {
            baseType: Number,
        },
        components: {
        },
        data() {
            return {
                formValidator: '',
                dateFormat: "yyyy-MM-dd HH:mm:ss",
                locale: localStorage.getItem('locale'),
                currentDay: new Date(),
                productList: [],
                monitorTask: {
                    taskName: '',
                    product: 'PLATFORM',
                    sampleStart: '',
                    sampleEnd: '',
                },
                monitorThresholdPo: {
                    cpuThreshold: '',
                    memoryThreshold: '',
                    spaceThreshold: '',
                },
                fieldsFormat: {
                    text: "text",
                    value: "value"
                },
                formatList: [
                    { text: "csv", value: "csv" },
                    { text: "excel", value: "excel" },
                ],
                validateOptions: {
                    customPlacement: function(inputElement, errorElement) {
                      console.log("******validateOptions-inputElement:", inputElement)
                      console.log("******validateOptions-errorElement:", errorElement)

                        inputElement = inputElement.closest('.form-group').querySelector('.error');
                        inputElement.parentElement.appendChild(errorElement);
                    },
                    rules: {
                        'taskName': {
                            required: [true, `${this.$t('Monitor.placeholder.taskName')}`],
                        },
                        // 'product': {
                        //     required: [true, `${this.$t('Monitor.placeholder.product')}`],
                        // },
                        'cpuThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'spaceThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'memoryThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'sampleStart': {
                            required: [true, `${this.$t('Monitor.placeholder.sampleStart')}`],
                        },
                        'sampleEnd': {
                            required: [true, `${this.$t('Monitor.placeholder.sampleEnd')}`],
                        },
                    }
                }
            }
        },
        methods: {
            init(){
                this.getProductList();
                this.formValidator = new FormValidator('#monitorTaskForm', this.validateOptions);
            },
            getProductList() {
                this.$axios.get("/lte/ems/sys/monitor/log/findProducts").then(response => {
                    let resultVal = response.data.resultVal;
                    resultVal = resultVal.filter(item => !item.includes('ems_5gc') && !item.includes('ems_gnb') && !item.includes('ems_tr069'));
                    for (let i = 0; i < resultVal.length; i++) {
                        this.productList.push({
                            text: resultVal[i],
                            value: resultVal[i],
                        });
                    }
                });
            },
            productChange() {
                this.monitorTask.product = msg.value;
            },
            getMonitorTask() {
                return {
                    monitorTask: {
                        taskName: this.monitorTask.taskName,
                        product: this.monitorTask.product,
                        sampleStart: (new Date(this.monitorTask.sampleStart)).getTime(),
                        sampleEnd: (new Date(this.monitorTask.sampleEnd)).getTime(),
                    },
                    monitorThresholdPo: {
                      cpuThreshold: this.monitorThresholdPo.cpuThreshold,
                      memoryThreshold: this.monitorThresholdPo.memoryThreshold,
                      spaceThreshold: this.monitorThresholdPo.spaceThreshold,
                    },
                 }
            },
            validation() {
              let status = this.formValidator.validate();
              return status;
            },
            stopEvent(event) {
                if (event.keyCode == 13) {
                    event.cancelBubble = true;
                    event.returnValue = false;
                    return false;
                }
            }
        }
    };
</script>
